"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LocaleProvider = _interopRequireDefault(require("./LocaleProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _LocaleProvider.default;
exports.default = _default;